import { render, staticRenderFns } from "./Investigation.vue?vue&type=template&id=fa402222&"
import script from "./Investigation.vue?vue&type=script&lang=js&"
export * from "./Investigation.vue?vue&type=script&lang=js&"
import style0 from "./Investigation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports